// extracted by mini-css-extract-plugin
var _1 = "I5I4ppkC";
var _2 = "vLbHp2yy";
var _3 = "vLbHp2yy";
var _4 = "KExRsxVq";
var _5 = "Rb2klU8X";
var _6 = "Rb2klU8X";
export { _1 as "info", _2 as "last-updated", _3 as "lastUpdated", _4 as "small", _5 as "waiting-room-page", _6 as "waitingRoomPage" }
